<script>
import { mapState } from 'vuex'
import VContentCard from '@/components/VContentCard'
const VWarningMessage = () => import('@/components/VWarningMessage')
const VImageTransition = () => import('@/components/VImageTransition')

export default {
  name: 'SuccessResetPasswordScreen',

  components: {
    VContentCard,
    VWarningMessage,
    VImageTransition,
  },

  computed: {
    ...mapState({
      clientLogo: 'clientLogo',
      clientName: 'clientName',
    }),
  },
}
</script>

<template>
  <VContentCard>
    <template slot="form">
      <div class="success-reset-password">
        <div class="success-reset-password__logo-content">
          <VImageTransition
            :image="clientLogo"
            :text="clientName"
          />
        </div>

        <div class="success-reset-password__content">
          <div class="success-reset-password__title">
            {{ $t('createNewPasswordSuccess') }}
          </div>

          <div class="success-reset-password__description">
            {{ $t('createNewPasswordReturnMessage') }}
          </div>
        </div>

        <router-link
          :to="{ name: 'loginScreen' }"
          class="inv-btn inv-btn--primary button-link"
        >
          {{ $t('returnToMainScreen') }}
        </router-link>
      </div>
    </template>
  </VContentCard>
</template>

<style scoped>
.button-link {
  max-width: 288px;
  width: 100%;
  min-height: 60px;
  background-color: #4693F8;
  text-decoration: none;
}
.success-reset-password {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 480px;
  margin-top: var(--space-24);
  margin-bottom: var(--space-24);
}

.success-reset-password__logo-content {
  min-height: 108px;
}

.success-reset-password__content {
  margin-top: 88px;
}

.success-reset-password__title {
  text-align: center;
  font-weight: var(--font-title--weight);
  font-size: var(--font-title--size);
  color: var(--color-default--dark);
}

.success-reset-password__description {
  margin-top: 6px;
  font-size: var(--font-content--size);
  color: var(--color-system--dark);
  align-self: center;
  text-align: center;
}

.inv-btn {
  margin-top: 125px;
  text-decoration: none;
  box-sizing: border-box;
}
</style>
